
module.exports.isDefined = function(value)
{
    return typeof value != 'undefined';
}

module.exports.isUndefined = function(value)
{
    return !this.isDefined(value);
}

module.exports.isDefinedAndTrue = function(value)
{
    return this.isDefined(value) && value;
}

module.exports.isDefinedAndFalse = function(value)
{
    return this.isDefined(value) && !value;
}

module.exports.isObject = function(value)
{
    // null is an object in javascript
    
    return typeof value === 'object' && value !== null;
}

module.exports.deepCloneObject = function(value)
{
    return JSON.parse(JSON.stringify(value));
}

module.exports.getPropertyValue = function (obj, propertyName)
{
    //
    // Returns property value where propertyName could possibly be a nested property like "stockItem.code"
    // in which case returns the nested property value obj["stockItem"]["code"] (obj.stockItem.code)
    //

    let value = obj;

    const propertyNames = propertyName.split(".");

    for (let i = 0; i < propertyNames.length; i++)
    {
        value = value[propertyNames[i]];
    }

    return value;
}
